import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5v70ir5zqm: FaireBrandEntity = {
  token: "b_5v70ir5zqm",
  type: "brand",
  name: "Misewell",
  avatarUrl:
    "https://cdn.faire.com/fastly/1aec5f4922965760549c4ec96d946ef5bca035040e6ed407e73d29c83827f4d6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4fa48873304e7d002f7c58ea16ed155b6e5553957795c7dba425105e7fbf3bf9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1aec5f4922965760549c4ec96d946ef5bca035040e6ed407e73d29c83827f4d6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4fa48873304e7d002f7c58ea16ed155b6e5553957795c7dba425105e7fbf3bf9.jpeg",
  location: "Milwaukee, WI, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 28,
  isInsider: true,
  description:
    "Misewell was established by brothers, Vincent and Paul Georgeson, with the belief that furnishing your home is about more than just making your home look good. They’re dedicated to their mission of designing well-made objects for the home that are not only beautiful and functional, but ethically and sustainably produced. Each piece is thoughtfully designed by Misewell and hand-made at their studio, or by skilled artists and craftspeople in communities across the United States.\n\nPlease use our Faire Direct link! https://misewell.faire.com   If you do tell us! Something may get added to your order as a thank you. ",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:08.182Z",
    importedBy: "entity-db-cli",
  },
};
